import React from 'react';
import Text from '@amzn/meridian/text';
import { FormattedMessage } from 'react-intl';
import DismissableAlert, {
  DismissableAlertProps,
} from '../../../commons/DismissableAlert';

export const ManagerWeeklyHighlightsDisclaimer = (
  props: DismissableAlertProps
) => (
  <DismissableAlert type='theme' size='medium' {...props}>
    <Text>
      <FormattedMessage
        id='cs_perfportal_weekly_highlights_manager_disclaimer'
        defaultMessage="Weekly highlights are an experimental feature generated by AI. They're only supported for select channels in limited marketplaces."
      />
    </Text>
  </DismissableAlert>
);
export const CSAWeeklyHighlightsDisclaimer = (props: DismissableAlertProps) => (
  <DismissableAlert type='theme' size='medium' {...props}>
    <Text>
      <FormattedMessage
        id='cs_perfportal_weekly_highlights_csa_disclaimer'
        defaultMessage="Weekly highlights are an experimental feature generated by AI. They're only supported for select channels in limited marketplaces. These highlights are informational and don't impact performance reviews."
      />
    </Text>
  </DismissableAlert>
);

export const SummariesErrorAlert = (props: DismissableAlertProps) => {
  return (
    <DismissableAlert type='error' size='medium' {...props}>
      <FormattedMessage
        id='cs_perfportal_weekly_highlights_error_alert'
        defaultMessage="<bold>Error</bold> We couldn't load the highlight. Please try again."
        values={{
          bold: chunks => <b>{chunks} </b>,
        }}
      />
    </DismissableAlert>
  );
};
